import React, { useState } from "react";
import { Col, Form, Modal, Row, Select } from "antd";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { dspxGetWorkerChildrens } from "../../../helpers/dspx-utils";
import { EditDocumentIcon } from "../../../resource/icons";
import actions from "../store/actions/edit-document.actions";
import AllModal from "./AllModal/AllModal";

const EditAppointedWorkerModal = ({
	editAppointedWorker,
	workersList,
	validateFields,
	getFieldDecorator,
	onCancel,
	visible,
	prepareDataAndResetFields,
	form,
}) => {
	const dispatch = useDispatch();
	const subject = "Исполнители";
	const subject_err = "исполнителей";

	const onAppointedWorkerChanged = useCallback(() => {
		validateFields((err, values) => {
			if (err) return;
			const valueDocument = prepareDataAndResetFields(values);
			const appointedWorkersArray = (valueDocument.appointedWorkers && valueDocument.appointedWorkers.length > 0) ? valueDocument.appointedWorkers.map((appointedWorker) => appointedWorker.id) : [];
			dispatch(
				actions.updateAppointedWorkers({
					workerIds: [...appointedWorkersArray, ...values.newAppointedWorkerId],
					docId: valueDocument.id
				}
				)
			);
			dispatch(actions.closeModal());
		});
	}, [validateFields]);

	const [stateAllModal, setStateAllModal] = useState(false);

	const currentValues = form.getFieldValue('newAppointedWorkerId');

	const openModal = () => {
		setStateAllModal(true)
	}

	const closeModal = () => {
		setStateAllModal(false)
	}

	return (
		<Modal
			style={{ minWidth: 400 }}
			width={500}
			visible={visible}
			title={
				<div style={{ display: "flex", alignItems: "center" }}>
					<EditDocumentIcon
						style={{
							height: 40,
							verticalAlign: "middle",
							marginRight: 10,
						}}
					/>
					<div>
						{editAppointedWorker
							? `Замена исполнителя ${editAppointedWorker.fullName}`
							: "Добавить исполнителей"}
					</div>
				</div>
			}
			okText="Добавить"
			onCancel={onCancel}
			onOk={onAppointedWorkerChanged}
		>
			<Form layout="vertical">
				<Row gutter={8}>
					<Col span={24}>
						<Form.Item label={subject}>
							{getFieldDecorator("newAppointedWorkerId", {
								initialValue: [],
								rules: [
									{
										required: true,
										message: "Пожалуйста, укажите " + subject_err,
									},
								],
							})(
								<Select
									showSearch
									placeholder='исполнители'
									notFoundContent="нет данных"
									optionLabelProp="label"
									optionFilterProp="searchtext"
									mode="multiple"
									maxTagCount={3}
									maxTagPlaceholder={(omittedValues) => (
										<span 
											onClick={(e) => {
												e.stopPropagation();
												e.preventDefault();
												openModal();
											}}
											style={{
												cursor: 'pointer',
												color: '#1890ff',
												marginLeft: 4,
												pointerEvents: 'auto'
											}}
										>
											{`Показать все ${omittedValues.length + 3}`}
										</span>
									)}
									onSelect={(value, option) => {
										if (value === 'SELECT_ALL') {
											const allValues = workersList.map(worker => worker.id);
											form.setFieldsValue({
												newAppointedWorkerId: allValues,
											});
										} else if (value === 'CLEAR_ALL') {
											form.setFieldsValue({
												newAppointedWorkerId: [],
											});
										}
									}}
								>
									<Select.Option value="SELECT_ALL" label="Выбрать всех" searchtext="выбрать всех">
										<b>Выбрать всех</b>
									</Select.Option>
									<Select.Option value="CLEAR_ALL" label="Снять всех" searchtext="снять всех">
										<b>Снять всех</b>
									</Select.Option>

									{dspxGetWorkerChildrens(workersList, undefined, true)}
								</Select>
							)}
						</Form.Item>
					</Col>
				</Row>
			</Form>
			<AllModal visible={stateAllModal} currentValues={currentValues} workersList={workersList} closeModal={closeModal} />
		</Modal>
	);
};

export default EditAppointedWorkerModal;
